import { Badge, Panel, TwoColumnLayout, VerticalContainer } from '@/components';
import { formatDateTime } from '@/lib/format';
import { ConsultationTypeEnum, getEnumTranslationByKey } from '@/shared/enums';
import { IConsultationDto, IConsultationMessageDto } from '@/shared/interfaces';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import {
    PropertyObjectType,
    PropertyType,
} from '@/caregiverSpace/shared/model';
import { PropertiesList } from '@/caregiverSpace/shared/ui';

type TextConsultationPanelProps = {
    consultation: IConsultationDto;
    messages: IConsultationMessageDto[];
};

const getConsultationProperties = (
    consultation: IConsultationDto,
    messages: IConsultationMessageDto[],
) => {
    const leftProperties: PropertyObjectType[] = [
        {
            label: R.Type,
            value: `${getEnumTranslationByKey(ConsultationTypeEnum, consultation.ConsultationType)}`,
            type: PropertyType.TEXT,
        },
        {
            label: R.CanWeInformYourGP,
            value: consultation.NotifyOwnDoctor ? R.Yes : R.No,
            type: PropertyType.TEXT,
        },
    ];

    const rightProperties: PropertyObjectType[] = [
        {
            label: R.Created,
            value: formatDateTime(consultation.CreatedOn),
            type: PropertyType.TEXT,
        },
        {
            label: R.LatestMessage,
            value:
                messages && messages.length > 0
                    ? formatDateTime(
                          new Date(
                              Math.max(
                                  ...messages.map((message) =>
                                      new Date(message.SentOn).getTime(),
                                  ),
                              ),
                          ),
                      )
                    : null,
            type: PropertyType.TEXT,
        },
    ];

    return { leftProperties, rightProperties };
};

export const TextConsultationPanel = ({
    consultation,
    messages,
}: TextConsultationPanelProps) => {
    const { leftProperties, rightProperties } = getConsultationProperties(
        consultation,
        messages,
    );

    return (
        <Panel>
            <VerticalContainer>
                <Badge type="default">{R.Consultation}</Badge>
                <TwoColumnLayout
                    leftColumn={<PropertiesList properties={leftProperties} />}
                    rightColumn={
                        <PropertiesList properties={rightProperties} />
                    }
                />
            </VerticalContainer>
        </Panel>
    );
};
